// otp-dialog.component.ts
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-otp-dialog',
  template: `
    <h2 mat-dialog-title>Enter OTP</h2>
    <mat-dialog-content>
      <p>Enter the OTP sent to {{ data.email }}</p>
      <mat-form-field>
        <input matInput [formControl]="otpControl" placeholder="OTP" required>
        <mat-error *ngIf="otpControl.hasError('required')">OTP is required</mat-error>
      </mat-form-field>
      <div>
        <button mat-button (click)="resendOtp()" [disabled]="isResending">
          {{ isResending ? 'Resending...' : 'Resend OTP' }}
        </button>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-button [disabled]="otpControl.invalid" (click)="onSubmit()">Verify</button>
    </mat-dialog-actions>
  `,
})
export class OtpDialogComponent {
  otpControl = new FormControl('', Validators.required);
  isResending = false; 

  constructor(
    public dialogRef: MatDialogRef<OtpDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { 
      email: string,
      sendverifyMail: any,
      snackBar: MatSnackBar 
    }
  ) {}

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onSubmit(): void {
    if (this.otpControl.valid) {
      this.dialogRef.close(this.otpControl.value);
    }
  }

  async resendOtp(): Promise<void> {
    this.isResending = true;
    try {
      await this.data.sendverifyMail.make();
      this.data.snackBar.open(
        'A new OTP has been sent to your email',
        '',
        { duration: 3000 }
      );
    } catch (err) {
      this.data.snackBar.open(
        'Failed to resend OTP. Please try again.',
        '',
        { duration: 3000 }
      );
      console.log('Resend OTP error:', err);
    } finally {
      this.isResending = false;
    }
  }
}